import { TemplateRef } from '@angular/core';

export interface ImportConfig<T> {
  allowImporting?: boolean;
  importTemplate?: TemplateRef<any>;
  onImport?: (rows: T[]) => void;
}
